export default __webpack_public_path__ + "static/media/Hair_15_F_C3.e64b641f.svg";